import gsap from 'gsap';
import Viewport from './core/Viewport';
import Components from './core/Components';
import lazySizes from './lib/lazysizes';
import Revealer from './lib/Revealer';
import Transitioner from './lib/Transitioner';
import Dispatch from './core/Dispatch';
import { isLivePreview } from './lib/helpers';
import { REDUCED_MOTION_CHANGE } from './lib/events';
import animatedScroll from './lib/animatedScroll';

gsap.defaults({ overwrite: 'auto' });

const init = () => {
    Viewport.init();
    Components.init();
    Viewport.initTabbing();
    lazySizes.init();

    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce), (update: slow)');

    const onReduceMotionChange = () => {
        if (!reduceMotionQuery.matches) {
            if (!isLivePreview()) {
                Revealer.init();
                Transitioner.init();
            }
        } else {
            Revealer.destroy();
            Transitioner.destroy();
        }
        Dispatch.emit(REDUCED_MOTION_CHANGE, !!reduceMotionQuery.matches);
    };

    onReduceMotionChange();

    reduceMotionQuery.onchange = onReduceMotionChange;

    // Init anchor links + modal triggers
    document.addEventListener('click', e => {
        // If user is holding Cmd (macOS) or Ctrl (Windows/Linux), let the default action happen
        if (e.metaKey || e.ctrlKey) {
            return; // Do not prevent default or run custom logic
        }

        // Find the closest anchor element to the clicked target
        const link = e.target.closest('a[href^="#"]');
        if (!link || !document.contains(link)) {
            return;
        }

        // Get the href
        const href = link.getAttribute('href');
        if (!href.length) {
            return;
        }

        // Anchor links
        if (href[0] === '#') {
            const targetId = link.getAttribute('href').replace('#', '');
            const target = document.getElementById(targetId);
            if (!target) {
                console.warn(`Target with ID ${targetId} does not exist in the document.`);
                return;
            }

            e.preventDefault();
            try {
                target.focus({ preventScroll: true });
            } catch (error) {
                console.error(error);
            }

            if (reduceMotionQuery.matches) {
                target.scrollIntoView({ behavior: 'auto' });
            } else {
                animatedScroll(target);
            }
        }
    });
};

require('doc-ready')(init);
